import { Controller } from '@hotwired/stimulus';
import '@/js/modules/jquery_modal_defaults';

export default class extends Controller {
  static targets = ['deleteForm'];

  open(event) {
    const deleteUrl = event.detail?.deleteUrl;
    if (deleteUrl) {
      this.deleteFormTarget.action = deleteUrl;
    }
    $(this.element).modal();
  }
}
